export default function mitraBantuanMiddleware({ env, store, redirect }) {
  if (!store.getters['auth/isUserLoggedIn'] && !store.getters['user/getMe'].name) {
    return redirect(`${env.WEB_HOST}/aplikasi-mitra`);
  }
}
